module.exports = __webpack_public_path__ + "static/media/container.a039ad16.svg";